
import { Component, Vue, Prop, Model, Watch } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import i18n from "@/config/i18n";
@Component({
  components: {}
})
export default class PiRateTime extends Vue {
  @Prop({ default: i18n.t("formText.timeNull") + "" })
  private placeholder!: string;
  @Prop({ default: "" }) private width!: string;
  @Prop({
    default: () => {
      return {};
    }
  })
  private data!: objAny;

  @Model("value", { type: Array }) private modelVlaue!: string[];
  @Watch("modelVlaue")
  getValue() {
    if (this.timeValue != this.modelVlaue.join("-")) {
      this.timeValue = this.modelVlaue.join("-");
    }
  }
  private timeValue = "00:00-00:00";
  private hourList: string[] = [];
  private minuteList: string[] = [];
  private valueObj: objAny = {
    0: "",
    1: "",
    2: "",
    3: ""
  };

  public getValueArr() {
    this.valueObj = {
      0: "",
      1: "",
      2: "",
      3: ""
    };
    if (this.timeValue != "") {
      const arr = this.timeValue.split(/[:-]/);
      arr.map((item: string, index: number) => {
        if (index < 4) {
          this.valueObj[index] = item;
        }
      });
    }
  }
  public timeClick(key: string, value: string) {
    if (key == "0") {
      if (parseInt(this.valueObj[2]) < parseInt(value)) {
        this.valueObj[2] = value;
        this.valueObj[key] = value;
      } else {
        this.valueObj[key] = value;
      }
    } else if (key == "1") {
      if (parseInt(this.valueObj[3]) < parseInt(value)) {
        this.valueObj[3] = value;
        this.valueObj[key] = value;
      } else {
        this.valueObj[key] = value;
      }
    } else if (key == "2") {
      if (parseInt(value) >= parseInt(this.valueObj[0])) {
        this.valueObj[key] = value;
      }
      if (parseInt(value) == 24) {
        this.valueObj[3] = "00";
      }
    } else if (key == "3") {
      if (
        parseInt(this.valueObj[2]) > parseInt(this.valueObj[0]) ||
        (parseInt(this.valueObj[2]) == parseInt(this.valueObj[0]) &&
          parseInt(value) > parseInt(this.valueObj[1]))
      ) {
        this.valueObj[key] = value;
      }
    } else {
      this.valueObj[key] = value;
    }
    const start: number = this.convertTimesToString(
      this.valueObj[0] + ":" + this.valueObj[1]
    );
    const end: number = this.convertTimesToString(
      this.valueObj[2] + ":" + this.valueObj[3]
    );

    if (start > end) {
      let i = 0;
      this.hourList.map((item: string, index: number) => {
        if (this.valueObj[2] == item) {
          i = index;
        }
      });
      this.valueObj[2] = this.hourList[i + 1];
    }
    this.timeValue =
      this.valueObj[0] +
      ":" +
      this.valueObj[1] +
      "-" +
      this.valueObj[2] +
      ":" +
      this.valueObj[3];
    this.$emit("value", this.timeValue.split("-"));
    this.$emit("on-change", this.timeValue.split("-"), this.data);
  }
  public convertTimesToString(data: string): number {
    const times = data.split(":");
    const str = Number(times[0]) * 100 + Number(times[1]);
    return str;
  }
  public initData() {
    this.timeValue = this.modelVlaue
      ? this.modelVlaue.join("-")
      : "00:00-00:00";
    console.log(this.timeValue);
    this.getValueArr();

    const hourList: string[] = [];
    for (let i = 0; i <= 24; i++) {
      const t: string = i < 10 ? "0" + i : i + "";
      hourList.push(t);
    }
    this.hourList = hourList;
    this.minuteList = ["00", "30"];
  }

  mounted() {
    this.initData();
  }
}
